export default __webpack_public_path__ + "static/media/Stopning af pølser film.8ba6fb9a.mp4";